<template>
	<div
		class="serenity__container"
		:style="
			`text-align: ${align}; width: ${width}; height: ${height}; margin-top: ${mt}; margin-bottom: ${mb}; margin-left: ${ml}; margin-right: ${mr}; padding: ${padding}; background: ${background}`
		"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		width: String,
		height: String,
		align: String,
		mt: String,
		mb: String,
		ml: String,
		mr: String,
		padding: String,
		background: String,
	},
};
</script>

<style lang="scss" scoped>
.serenity__container {
}
</style>
